import differenceInYears from "date-fns/differenceInYears";

export function ageAtDate(birth: Date, date: Date): number {
  return differenceInYears(date, birth);
}
